import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {
  ageTickFormatter,
  ageTickFormatterCase2,
  priceResult,
  formatKR,
} from "@assets/utils/check";

const CustomTooltip = ({ active, payload, label, text }) => {
  // const newData = dayjs(label).format("YY.MM.DD");
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 15,
          paddingRight: 15,
          backgroundColor: "white",
          border: "1px solid #EEEEEF",
          borderRadius: "5px",
        }}
      >
        <div
          className="label"
          style={{
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          {ageTickFormatterCase2(label)}
        </div>
        <div
          style={{
            fontSize: 14,
          }}
        >
          {text} : {priceResult(payload[0].value)}
        </div>
      </div>
    );
  }

  return null;
};

const SimpleBarChart = ({ data, text }) => {
  let totalCheck = 0;
  for (let index = 0; index < data.length; index++) {
    totalCheck = totalCheck + data[index].total;
  }
  return (
    <Grid sx={{ width: 600, height: 400 }}>
      {totalCheck !== 0 ? (
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            width={500}
            height={300}
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="name"
              xisLine={true}
              tickLine={false}
              style={{
                fontSize: "12px",
              }}
              tickFormatter={ageTickFormatter}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              style={{
                fontSize: "12px",
              }}
              tickFormatter={formatKR}
            />
            <Tooltip
              content={<CustomTooltip text={text} />}
              cursor={{ fill: "#F6F6F8" }}
            />
            {/* <Legend /> */}
            {/* <Bar dataKey="pv" fill="#8884d8" /> */}
            <Bar dataKey="total" fill="#129BFF" />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ height: "100%" }}
        >
          <Typography sx={{ fontSize: 14, color: "#9A9A9B" }}>
            데이터 없음
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default SimpleBarChart;
